if (!customElements.get('variant-picker')) {
	const {getVariantFromOptionArray} = window.FoxTheme.ProductHelper
	class VariantPicker extends HTMLElement {
		constructor() {
			super()
			this.selectors = {
				container: '[data-variant-picker]',
				variantIdInput: 'input[name="id"]',
				pickerFields: ['[data-picker-field]'],
				optionNodes: ['.variant-picker__option'],
				productSku: '[data-product-sku]',
				productAvailability: '[data-product-availability]',
				shareUrlInput: '[data-share-url]',
			}
			this.container = this.closest(this.selectors.container)
			this.domNodes = queryDomNodes(this.selectors, this.container)
			this.brakeField = this.querySelector('[data-brake-option]')

			this.setupData()
			this.initOptionSwatches()
			this.addEventListener('change', this.onVariantChange)
		}

		async setupData() {

			this.productId = this.container.dataset.productId
			this.sectionId = this.container.dataset.section
			this.productUrl = this.container.dataset.productUrl
			this.productHandle = this.container.dataset.productHandle
			this.productOption2IsMain = this.container.dataset.productOption2IsMain
			this.section = this.container.closest(`[data-section-id="${this.sectionId}"]`)
			this.variantData = this.getVariantData()
			this.metaData = this.getVariantMeta()
			this.productData = await this.getProductJson(this.productUrl)

			// console.log('meta', this.metaData)

			const selectedVariantId = this.section && this.section.querySelector(this.selectors.variantIdInput).value
			this.currentVariant = this.variantData.find(variant => variant.id === Number(selectedVariantId))
			if (this.currentVariant) {
				this.hideSoldOutAndUnavailableOptions()
			}

			if (this.isOption2IsMain() && this.currentVariant.available === false) {
				this.onVariantChange()
			}
			else {
				this.updateMedia()
				this.updateVariantPhotoBadge()
			}
		}

		onVariantChange(event) {
			const previousVariant = this.currentVariant
			this.getSelectedOptions()
			this.getSelectedVariant(event?.target.closest('[data-picker-field]'))
			if (this.brakeField && this.currentVariant && previousVariant?.id !== this.currentVariant.id && this.dataset.updateUrl !== 'false') {
				const hasCustomGallery = [previousVariant, this.currentVariant].some(variant =>
					this.metaData.find(meta => meta.id === variant?.id)?.values.variant_media?.length
				)
				if (hasCustomGallery) {
					window.location.href = `${this.productUrl}?variant=${this.currentVariant.id}`
					return
				}
			}
			this.updateButton(true, '', false)
			this.updatePickupAvailability()
			this.removeErrorMessage()

			if (this.currentVariant) {
				this.updateEstimateDelivery()
				this.updateProperties()
			}
			this.updateVariantPhotoBadge()

			if (!this.currentVariant) {
				this.updateButton(true, '', true)
				this.setUnavailable()
			} else {
				this.updateMedia()
				this.updateBrowserHistory()
				this.updateVariantInput()
				this.updateProductMeta()
				this.updatePrice()
				this.updateShareUrl()
				this.updateButton(!this.currentVariant.available, window.FoxThemeStrings.soldOut)
				this.hideSoldOutAndUnavailableOptions()
			}

			window.FoxThemeEvents.emit(`${this.productId}__VARIANT_CHANGE`, this.currentVariant, this)
		}

		getProductJson(productUrl) {
			return fetch(productUrl + '.js').then(function (response) {
				return response.json()
			})
		}

		getSelectedVariant(changedField) {
			if (this.brakeField) {
				const positions = this.domNodes.pickerFields.map(field => Number(field.dataset.optionPosition) - 1)
				const brakeIndex = Number(this.brakeField.dataset.optionPosition) - 1
				const matching = indexes => this.variantData.filter(variant =>
					indexes.every(index => variant.options[index] === this.options[index])
				)
				let candidates = matching(positions)
				// Changing color may require a different brake; changing the brake
				// must never silently select another color or ignore that choice.
				if (!candidates.length && changedField && changedField !== this.brakeField) {
					candidates = matching(positions.filter(index => index !== brakeIndex))
				}
				this.currentVariant = candidates.find(variant => variant.available) || candidates[0]
				if (this.currentVariant) {
					this.options = [...this.currentVariant.options]
					this.updateSelectedOptions()
				}
				return
			}
			let variant = getVariantFromOptionArray(this.productData, this.options)
			let options = [...this.options]
			if (!variant || variant.available === false) {
				let availableVariants = this.isOption2IsMain() ? this.productData.variants
					.filter(variant => variant.available && variant.option2 === options[1]) : false;
				if (availableVariants) {
					options = availableVariants[0].options
				}
				else {
					options.pop()
				}
				variant = getVariantFromOptionArray(this.productData, options)
				if (!variant) {
					options.pop()
					variant = getVariantFromOptionArray(this.productData, options)
				}
				if (variant && variant.options) {
					this.options = [...variant.options]
				}
				this.updateSelectedOptions()
			}
			this.currentVariant = variant
		}

		getSelectedOptions() {
			const pickerFields = Array.from(this.querySelectorAll('[data-picker-field]'))
			if (this.brakeField) {
				this.options = [...(this.currentVariant?.options || [])]
				pickerFields.forEach(field => {
					const input = field.querySelector('input:checked, select')
					if (input) this.options[Number(field.dataset.optionPosition) - 1] = input.value
				})
				return
			}
			this.options = pickerFields.map((field) => {
				const type = field.dataset.pickerField
				if (type === 'radio') return Array.from(field.querySelectorAll('input')).find((radio) => radio.checked).value
				return field.querySelector('select') && field.querySelector('select').value
			})
		}

		updateSelectedOptions() {
			this.domNodes.pickerFields.forEach((field, index) => {
				if (this.brakeField) index = Number(field.dataset.optionPosition) - 1
				const selectedValue = field.dataset.selectedValue
				if (selectedValue !== this.options[index]) {
					if (this.brakeField && field.dataset.pickerField === 'select') {
						field.querySelector('select').value = this.options[index]
						field.updateSelectedValue()
						return
					}
					const selectedOption = field.querySelector(`input[value="${this.options[index]}"]`)
					if (selectedOption) {
						selectedOption.checked = true
						field.updateSelectedValue()
					}
				}
			})
		}

		updateMedia() {
			if (!this.currentVariant) return
			if (!this.currentVariant.featured_media) return
			const mediaGallery = this.section.querySelector('media-gallery')
			mediaGallery && mediaGallery.setActiveMedia(this.currentVariant.featured_media.id)
		}

		updateBrowserHistory() {
			if (!this.currentVariant || this.dataset.updateUrl === 'false') return
			window.history.replaceState({}, '', `${this.productUrl}?variant=${this.currentVariant.id}`)
		}

		updateShareUrl() {
			const url = `${window.location.origin}${this.productUrl}?variant=${this.currentVariant.id}`
			const shareUrlInput = document.querySelectorAll(this.selectors.shareUrlInput)
			shareUrlInput && shareUrlInput.forEach(input => input.setAttribute('value', url))
		}

		updateVariantInput() {
			const productForms = document.querySelectorAll(`#product-form-${this.sectionId}, #product-form-installment`)
			productForms.forEach((productForm) => {
				const variantIdInput = productForm.querySelector(this.selectors.variantIdInput)
				variantIdInput.value = this.currentVariant.id
				variantIdInput.dispatchEvent(new Event('change', {bubbles: true}))
			})
		}

		updatePickupAvailability() {
			const pickUpAvailability = this.section && this.section.querySelector('pickup-availability')
			if (!pickUpAvailability) return

			if (this.currentVariant && this.currentVariant.available) {
				pickUpAvailability.fetchAvailability(this.currentVariant.id)
			} else {
				pickUpAvailability.removeAttribute('available')
				pickUpAvailability.innerHTML = ''
			}
		}

		updateEstimateDelivery() {
			if (typeof bikyDefaultDeliveryText === 'undefined') return
			let innerHtml = bikyDefaultDeliveryText;
			let currentVariantMeta = this.getVariantMeta().find(meta => meta.id === this.currentVariant.id)

			if (currentVariantMeta.values.variant_preorder_text) {
				innerHtml = `<strong> ${currentVariantMeta.values.variant_preorder_text} </strong>`;
			}

			document.querySelectorAll(".delivery-text")[0].innerHTML = innerHtml;
		}

		updateProperties() {
			const currentVariantMeta = this.getVariantMeta().find(meta => meta.id === this.currentVariant.id)
			const settings = [
				{
					id: 'f-product-single__block-biky-balloon',
					innerHTML: () => currentVariantMeta.weight_display !== undefined
						? `Weight: ${currentVariantMeta.weight_display}`
						: ''
				},
				{
					id: 'f-product-single__block-biky-height',
					innerHTML: () => currentVariantMeta.values.variant_height !== undefined
						? `Height: ${currentVariantMeta.values.variant_height[0].value}-${currentVariantMeta.values.variant_height[1].value} inches`
						: ''
				},
				{
					id: 'f-product-single__block-biky-inseam',
					innerHTML: () => currentVariantMeta.values.variant_inseam !== undefined
						? `Inseam: ${currentVariantMeta.values.variant_inseam[0].value}-${currentVariantMeta.values.variant_inseam[1].value} inches`
						: ''
				},

			];

			settings.forEach(block => {
				const innerHtml = block.innerHTML();
				const container = document.querySelector(`#${block.id}`);
				if (innerHtml.length > 0 && container) {
					container.innerHTML = block.innerHTML();
				}
			})
		}

		updateVariantPhotoBadge() {
			const leBadge = document.querySelector('.biky-le-badge-product-page');
			const photoBadge = document.querySelector('[data-variant-photo-badge]');

			if (leBadge) {
				const isLE = this.currentVariant && ['option1', 'option2', 'option3'].some(opt => ['le', 'limited-edition'].includes((this.currentVariant[opt] || '').trim().toLowerCase().replace(/\s+/g, '-')));
				leBadge.style.display = isLE ? '' : 'none';
			}

			if (photoBadge) {
				const currentVariantMeta = this.currentVariant && this.getVariantMeta().find(meta => meta.id === this.currentVariant.id);
				const badgeHtml = currentVariantMeta && currentVariantMeta.values.variant_photo_badge;
				if (badgeHtml) {
					photoBadge.innerHTML = badgeHtml;
					photoBadge.style.display = '';
				} else {
					photoBadge.innerHTML = '';
					photoBadge.style.display = 'none';
				}
			}
		}

		removeErrorMessage() {
			const section = this.closest('section')
			if (!section) return

			const productForm = section.querySelector('product-form')
			// if (productForm) productForm.handleErrorMessage()
		}

		updateSoldOutBadge() {
			const badges = this.section.querySelector('.f-price [data-soldout-badge]')
			if (!badges) return

			let badge = badges.querySelector('.f-price__badge-sold-out')
			if (!this.currentVariant || this.currentVariant.available) {
				if (badge) badge.remove()
				return
			}

			if (!badge) {
				badge = document.createElement('div')
				badge.className = 'f-price__badge-sold-out'
				const label = document.createElement('span')
				label.className = 'f-badge f-badge--soldout'
				badge.appendChild(label)
				badges.appendChild(badge)
			}

			const variantMeta = this.getVariantMeta().find(meta => meta.id === this.currentVariant.id)
			badge.querySelector('.f-badge--soldout').textContent =
				variantMeta?.values?.variant_preorder_text || window.FoxThemeStrings.soldOut
		}

		updatePrice() {
			this.updateSoldOutBadge()
			const classes = {
				onSale: 'f-price--on-sale',
				soldOut: 'f-price--sold-out'
			}
			const selectors = {
				priceWrapper: '.f-price',
				salePrice: '.f-price-item--sale',
				compareAtPrice: ['.f-price-item--regular'],
				unitPrice: '.f-price__unit',
				saleBadge: '.f-price__badge-sale',
				saleAmount: '[data-sale-value]'
			}
			const money_format = window.FoxThemeSettings.money_format
			const {
				priceWrapper,
				salePrice,
				unitPrice,
				compareAtPrice,
				saleBadge,
				saleAmount
			} = queryDomNodes(selectors, this.section)

			const {compare_at_price, price, unit_price_measurement} = this.currentVariant

			const onSale = compare_at_price && compare_at_price > price
			const soldOut = !this.currentVariant.available

			if (onSale) {
				priceWrapper.classList.add(classes.onSale)
			} else {
				priceWrapper.classList.remove(classes.onSale)
			}

			if (soldOut) {
				priceWrapper.classList.add(classes.soldOut)
			} else {
				priceWrapper.classList.remove(classes.soldOut)
			}

			if (priceWrapper) priceWrapper.classList.remove('visibility-hidden')
			if (salePrice) salePrice.innerHTML = formatMoney(price, money_format).replace('.00', '')

			if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
				compareAtPrice.forEach(item => item.innerHTML = formatMoney(compare_at_price, money_format).replace('.00', ''))
			} else {
				compareAtPrice.forEach(item => item.innerHTML = formatMoney(price, money_format).replace('.00', ''))
			}

			if (saleBadge && compare_at_price > price) {
				const type = saleBadge.dataset.type
				if (type === 'text') return
				let value
				if (type === 'percentage') {
					const saving = (compare_at_price - price) * 100 / compare_at_price
					value = Math.floor(saving) + '%'
				}
				if (type === 'fixed_amount') {
					value = formatMoney(compare_at_price - price, money_format)
				}

				saleAmount.textContent = value
			}

			if (unit_price_measurement && unitPrice) {
				unitPrice.classList.remove('f-hidden')
				const unitPriceContent = `<span>${formatMoney(this.currentVariant.unit_price, money_format)}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`
				unitPrice.innerHTML = unitPriceContent
			} else {
				unitPrice.classList.add('f-hidden')
			}
		}

		_getBaseUnit() {
			return this.currentVariant.unit_price_measurement.reference_value === 1
				? this.currentVariant.unit_price_measurement.reference_unit
				: this.currentVariant.unit_price_measurement.reference_value +
				this.currentVariant.unit_price_measurement.reference_unit
		}

		updateButton(disable = true, text, modifyClass = true) {
			const productForm = document.getElementById(`product-form-${this.sectionId}`)
			if (!productForm) return
			const addButton = productForm.querySelector('[name="add"]')
			const addButtonText = productForm.querySelector('[name="add"] > span:not(.f-icon)')

			if (!addButton) return

			if (disable) {
				addButton.setAttribute('disabled', 'disabled')
				if (text) addButtonText.textContent = text
			} else {
				addButton.removeAttribute('disabled')
				addButtonText.textContent = window.FoxThemeStrings.addToCart
			}
		}

		updateProductMeta() {
			const {available, sku, noSku} = this.currentVariant
			const {inStock, outOfStock} = window.FoxThemeStrings
			const productAvailability = this.section && this.section.querySelector(this.selectors.productAvailability)
			const productSku = this.section && this.section.querySelector(this.selectors.productSku)

			if (productSku) {
				if (sku) {
					productSku.textContent = sku
				} else {
					productSku.textContent = noSku
				}
			}

			if (productAvailability) {
				if (available) {
					productAvailability.textContent = inStock
					productAvailability.classList.remove('out-of-stock')
				} else {
					productAvailability.textContent = outOfStock
					productAvailability.classList.add('out-of-stock')
				}
			}
		}

		setUnavailable() {
			this.updateSoldOutBadge()
			const button = document.getElementById(`product-form-${this.sectionId}`)
			const addButton = button.querySelector('[name="add"]')
			const addButtonText = button.querySelector('[name="add"] > span:not(.f-icon)')
			const priceWrapper = this.section.querySelector('.f-price')
			if (!addButton) return
			addButtonText.textContent = window.FoxThemeStrings.unavailable
			if (priceWrapper) priceWrapper.classList.add('visibility-hidden')
		}

		hideSoldOutAndUnavailableOptions() {
			if (this.brakeField) {
				const brakeIndex = Number(this.brakeField.dataset.optionPosition) - 1
				const positions = this.domNodes.pickerFields.map(field => Number(field.dataset.optionPosition) - 1)
				this.domNodes.optionNodes.forEach(node => {
					const index = Number(node.dataset.optionPosition) - 1
					const candidates = this.variantData.filter(variant =>
						variant.options[index] === node.dataset.value &&
						(index !== brakeIndex || positions.every(position =>
							position === brakeIndex || variant.options[position] === this.currentVariant.options[position]
						))
					)
					const unavailable = !candidates.length
					const soldOut = candidates.length > 0 && candidates.every(variant => !variant.available)
					node.classList.toggle('variant-picker__option--soldout', soldOut)
					const input = node.querySelector('input')
					if (input) input.disabled = unavailable
					if (node.tagName === 'OPTION') node.disabled = unavailable
				})
				return
			}
			const classes = {
				soldOut: 'variant-picker__option--soldout'
				// unavailable: 'variant-picker__option--unavailable' TODO без этого опции цвета не отображаются
			}
			const variant = this.currentVariant
			const {optionNodes} = this.domNodes
			const {
				productData,
				productData: {variants, options: {length: maxOptions}}
			} = this

			optionNodes.forEach(optNode => {
				const {optionPosition, value} = optNode.dataset
				const optPos = Number(optionPosition)
				const isSelectOption = optNode.tagName === 'OPTION'

				let matchVariants = []
				if (optPos === maxOptions) {
					const optionsArray = Array.from(variant.options)
					optionsArray[maxOptions - 1] = value
					matchVariants.push(getVariantFromOptionArray(productData, optionsArray))
				} else {
					matchVariants = variants.filter(v => v.options[optPos - 1] === value && v.options[optPos - 2] === variant[`option${optPos - 1}`])
				}

				matchVariants = matchVariants.filter(Boolean)
				if (matchVariants.length) {
					optNode.classList.remove(classes.unavailable)
					isSelectOption && optNode.removeAttribute('disabled')
					const isSoldOut = matchVariants.every(v => v.available === false)
					const method = isSoldOut ? 'add' : 'remove'
					this.isOption2IsMain() || optNode.classList[method](classes.soldOut)
				} else {
					optNode.classList.add(classes.unavailable)
					isSelectOption && optNode.setAttribute('disabled', 'true')
				}
			})
		}


		getVariantData() {
			this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent)
			return this.variantData
		}

		getVariantMeta() {
			this.metaData = this.metaData || JSON.parse(this.container.querySelector('[type="application/json-lines"]').textContent)
			return this.metaData
		}

		initOptionSwatches() {
			const {colorSwatches = []} = window.FoxThemeSettings
			this.domNodes.optionNodes.forEach(optNode => {
				let variantImage
				const {optionPosition, value, fallbackValue, optionType, hasCustomImage} = optNode.dataset
				if (optionType === 'color') {
					// берем первый с картинкой
					const variant = this.variantData.find(v =>
						v[`option${optionPosition}`] && 
						v[`option${optionPosition}`].toLowerCase() === value.toLowerCase() &&
						v.featured_image
					) ||
					this.variantData.find(v =>
						v[`option${optionPosition}`] && 
						v[`option${optionPosition}`].toLowerCase() === value.toLowerCase()
					)
					const check = colorSwatches.find(c => c.key.toLowerCase() === value.toLowerCase())
					const customColor = check ? check.value : ''

					if (variant && optionType === 'color' && hasCustomImage !== 'true') {
						variantImage = variant.featured_image ? variant.featured_image.src : ''
						if (variantImage && !customColor) {
							optNode.querySelector('label').style = `background-image: url(${ getSizedImageUrl(variantImage, '60x')}) !important;`
						}
					}

					if (customColor) {
						optNode.style.setProperty('--option-color', `${customColor}`)
					}

					if (!customColor && !variantImage) {
						optNode.style.setProperty('--option-color', `${fallbackValue}`)
					}
					
					// Добавляем обработчик клика для перехода на страницу с вариантом
					const radioInput = optNode.querySelector('input[type="radio"]')
					if (radioInput && variant && !this.brakeField) {
						radioInput.addEventListener('click', (e) => {
							// Проверяем, есть ли у варианта кастомные медиа
							const variantMeta = this.metaData.find(meta => meta.id === variant.id)
							if (variantMeta && variantMeta.values && variantMeta.values.variant_media) {
								// Если есть кастомные медиа, переходим на страницу с вариантом
								e.preventDefault()
								e.stopPropagation()
								window.location.href = `${this.productUrl}?variant=${variant.id}`
								return false
							}
						})
					}
					
					return false;
				}
			})
		}

		isOption2IsMain() {
			return this.productOption2IsMain === 'true';
		}
	}

	customElements.define('variant-picker', VariantPicker)
}
if (!customElements.get('variant-button')) {
	class VariantButton extends HTMLElement {
		constructor() {
			super()
			this.selectedSpan = this.querySelector('.selected-value')
			this.addEventListener('change', this.updateSelectedValue)
		}

		updateSelectedValue() {
			const selectedInput = Array.from(this.querySelectorAll('input')).find((radio) => radio.checked)
			this.value = selectedInput.value
			this.setAttribute('data-selected-value', this.value)
			if (this.selectedSpan) this.selectedSpan.textContent = selectedInput.dataset.displayValue || this.value
		}
	}

	customElements.define('variant-button', VariantButton)

	if (!customElements.get('variant-select')) {
		class VariantSelect extends VariantButton {
			constructor() {
				super()
			}

			updateSelectedValue() {
				const select = this.querySelector('select')
				this.value = select.value
				this.setAttribute('data-selected-value', this.value)
				if (this.selectedSpan) this.selectedSpan.textContent = select.selectedOptions[0].dataset.displayValue || this.value
			}
		}

		customElements.define('variant-select', VariantSelect)
	}
	if (!customElements.get('variant-image')) {
		class VariantImage extends VariantButton {
			constructor() {
				super()
			}
		}

		customElements.define('variant-image', VariantImage)
	}
	if (!customElements.get('variant-color')) {
		class VariantColor extends VariantButton {
			constructor() {
				super()
			}
		}
		customElements.define('variant-color', VariantColor)
	}
}
